import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import useLogActivityAccess from '../hooks/useLogActivityAccess';
import api from '../services/api';
import './Vocabulario.css';

function speak(text) {
  if (!window.speechSynthesis) return;
  window.speechSynthesis.cancel();
  const utter = new SpeechSynthesisUtterance(text);
  utter.lang = 'en-US';
  utter.rate = 0.85;
  window.speechSynthesis.speak(utter);
}

export default function Vocabulario() {
  useLogActivityAccess('vocabulario');

  const [categorias, setCategorias] = useState([]);
  const [loading,    setLoading]    = useState(true);
  const [category,   setCategory]   = useState(null);

  useEffect(() => {
    api.get('/vocabulario')
      .then(res => setCategorias(res.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="vocab-page">
        <div className="vocab-loading"><i className="fas fa-spinner fa-spin fa-2x" /></div>
      </div>
    );
  }

  if (category) {
    return (
      <div className="vocab-page">
        <button className="vocab-back-btn" onClick={() => setCategory(null)}>
          <i className="fas fa-arrow-left" /> Voltar às categorias
        </button>

        <h1 className="vocab-title">
          <i className={category.icon} style={{ color: category.color }} />
          {category.titulo}
        </h1>
        <p className="vocab-subtitle">Clique em uma palavra para ouvir a pronúncia em inglês.</p>

        {category.words.length === 0 ? (
          <div className="vocab-loading">Nenhuma palavra cadastrada nesta categoria ainda.</div>
        ) : (
          <div className="vocab-word-grid">
            {category.words.map(w => (
              <button key={w.id} className="vocab-word-card" onClick={() => speak(w.en)}>
                <span className="vocab-word-emoji">{w.emoji}</span>
                <span className="vocab-word-en">{w.en}</span>
                <span className="vocab-word-pt">{w.pt}</span>
                <i className="fas fa-volume-up vocab-word-icon" />
              </button>
            ))}
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="vocab-page">
      <Link to="/atividades" className="vocab-back-btn">
        <i className="fas fa-arrow-left" /> Voltar às atividades
      </Link>

      <h1 className="vocab-title">
        <i className="fas fa-spell-check" style={{ color: '#1e90ff' }} />
        Vocabulário
      </h1>
      <p className="vocab-subtitle">Escolha uma categoria para aprender novas palavras em inglês.</p>

      {categorias.length === 0 ? (
        <div className="vocab-loading">Nenhuma categoria cadastrada ainda.</div>
      ) : (
        <div className="vocab-category-grid">
          {categorias.map(cat => (
            <button
              key={cat.id}
              className="vocab-category-card"
              style={{ '--cat-color': cat.color }}
              onClick={() => setCategory(cat)}
            >
              <i className={cat.icon} />
              <span>{cat.titulo}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
